import React from 'react';
import { useQuery } from '@apollo/client';
import { GET_UPDATE_PAYMENT_METHOD_URL_FLEX } from '../../../../services/ApolloClient';
import { UpdatePaymentMethodFlexData } from '../../../../types/flex';

export const UpdatePaymentMethodFlex = () => {
  const {
    data: updatePaymentMethodFlexData,
    loading: updatePaymentMethodFlexLoading,
    error: updatePaymentMethodFlexError,
  } = useQuery<UpdatePaymentMethodFlexData>(GET_UPDATE_PAYMENT_METHOD_URL_FLEX, {
    fetchPolicy: 'no-cache',
    variables: {
      forceUpdate: true,
    },
  });
  if (updatePaymentMethodFlexError || updatePaymentMethodFlexLoading) {
    return null;
  }
  return (
    <div style={{ marginTop: '10px', marginBottom: '10px' }}>
      <a
        className="action-link"
        target="_self"
        href={updatePaymentMethodFlexData?.getUpdatePaymentMethodUrlFlex?.url || '#'}
        rel="noreferrer"
      >
        Update payment method
      </a>
    </div>
  );
};
